import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { STATUS } from "utils/status";
import api from "api";

// State type
interface Log {
  type: any;
  id: number;
  sub_project_id: string;
  auth_token: string;
  request_method: string;
  request_status: string;
  end_point: string;
  platform: string;
  request_data: any;
  response_data: any;
  timestamp?: string; // if backend adds timestamp later
}

interface LogsState {
  logs: Log[];
  count: number;
  next: string | null;
  previous: string | null;
  getLogsStatus: STATUS;
  error: string | null;
}

const initialState: LogsState = {
  logs: [],
  count: 0,
  next: null,
  previous: null,
  getLogsStatus: STATUS.NOT_STARTED,
  error: null,
};

export const getLogs = createAsyncThunk(
  "project/logs/get",
  async (payload: { project_id: string; page?: number, type: string, start_date:any, end_date:any, rows_per_page:any  }, thunkAPI) => {
    try {
      const { project_id, page, type, start_date, end_date, rows_per_page } = payload;
      const response = await api.get('logs/request_response_logs_api', {
        params: {
          project_id,
          page,
          rows_per_page,
          type,
          start_date,
          end_date,
        },
      });

      const { status, data } = response;
      if (status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

const logsSlice = createSlice({
  name: "logs",
  initialState,
  reducers: {
    resetLogsState(state) {
      state.logs = [];
      state.count = 0;
      state.next = null;
      state.previous = null;
      state.getLogsStatus = STATUS.NOT_STARTED;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLogs.pending, (state) => {
        state.getLogsStatus = STATUS.PENDING;
        state.error = null;
      })
      .addCase(getLogs.fulfilled, (state, action) => {
        state.getLogsStatus = STATUS.SUCCESS;
        state.logs = action.payload.results || [];
        state.count = action.payload.count;
        state.next = action.payload.next;
        state.previous = action.payload.previous;
      })
      .addCase(getLogs.rejected, (state, action) => {
        state.getLogsStatus = STATUS.FAILED;
        state.error = action.payload as string;
      });
  },
});

export const { resetLogsState } = logsSlice.actions;
export default logsSlice.reducer;


